import React, { useEffect, useState } from 'react';

import websitelogo from '../../../../assets/logos/sidebarFullLogoPng.png';

import SearchIcon from '@mui/icons-material/Search';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import WebLogo from '../../../../assets/logos/websitelogo.svg';

import '../../dashboard/Dashboard.css';

import {
	Box,
	CssBaseline,
	Grid,
	IconButton,
	Input,
	InputBase,
	Paper,
	Typography,
} from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useNavigate, Link } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import LanguageIcon from '@mui/icons-material/Language';
import logo from '../../../../assets/logos/websitelogo.svg';

import Button from '@mui/material/Button';

import {
	aboutUs,
	getPractices,
	getVisitCount,
} from '../../../services/api/apiManager';
import { getAccessToken } from '../../../services/Settings';
import { useStateValue } from '../../../services/state/State';
import { actions } from '../../../services/state/Reducer';
const accessToken = `${getAccessToken}`;

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import { styled, useTheme } from '@mui/material/styles';

import '../selectPractice/SelectPracticev2';

import MuiDrawer from '@mui/material/Drawer';

import MuiAppBar from '@mui/material/AppBar';

import Toolbar from '@mui/material/Toolbar';

import logoutPng from '../../../../assets/logos/logoutIcons.png';

import MenuIcon from '@mui/icons-material/Menu';

import { Menu, MenuItem, Modal, Tooltip } from '@mui/material';

import { Outlet, useLocation } from 'react-router';

import {
	ArrowBackIos,
	ArrowForwardIos,
	Feedback,
	Refresh,
	Sync,
} from '@mui/icons-material';
import { logout } from '../../../services/api/apiManager';
import FeedbackPopup from '../../../main/accounts/feedback/FeedbackPopup';
import Slider from 'react-slick';
import { id } from 'date-fns/locale';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	p: 4,
	borderRadius: '10px',
};

const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
	backgroundColor: '#0E4374',
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	backgroundColor: '#0E4374',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const AppBar = styled(MuiAppBar, {
	shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
	zIndex: theme.zIndex.drawer + 1,
	transition: theme.transitions.create(['width', 'margin'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	}),
}));

// logout button function is here
export const logoutFunc = async () => {
	const refreshToken = { refresh_token: localStorage.getItem('refreshtoken') };
	localStorage.removeItem('accessToken');
	localStorage.removeItem('user');
	localStorage.removeItem('refreshtoken');
	localStorage.removeItem('loginTime');
	localStorage.removeItem('practice_id');
	localStorage.removeItem('userName');
	localStorage.removeItem('prName');
	localStorage.removeItem('OSW_id');
	localStorage.removeItem('OID');
	const resp = await logout(refreshToken);
	// console.log(resp);
};

function SelectPracticev2() {
	const navigate = useNavigate();
	const [searchText, setSearchText] = useState('');
	const [{ practices, practicestats }, dispatch] = useStateValue();
	// const [practices, setPractices] = useState([]);
	const visitcounts = practicestats?.visits || [];
	const [sliderData, setSliderData] = useState([]);

	const sliderApiData = async () => {
		try {
			const resp = await aboutUs();
			setSliderData(resp?.data);
		} catch (error) {
			console.log('error', error);
		}
	};

	const handlepractice = (practice) => {
		// Navigate to the signup page
		dispatch({ type: actions.SET_SELECTED_PRACTICE, payload: practice });
		localStorage.setItem('practice_id', practice?.id);
		localStorage.setItem('prName', practice?.Name);
		localStorage.setItem('OSW_id', practice?.OSW_id);
		localStorage.setItem('OID', practice?.OID);
		navigate('/dashboard');
	};
	const fetchPractices = async () => {
		try {
			setLoading(true);
			const response = await getPractices();
			if (response?.status === 200) {
				// setPractices(response?.data); // Assuming response.data contains the list of practices
				dispatch({
					type: actions.SET_PRACTICES,
					payload: response?.data?.filter((items) => items?.Inactive !== true),
				});
			} else {
				// setPractices([]);
				dispatch({ type: actions.SET_PRACTICES, payload: [] });
			}
			setLoading(false);
		} catch (error) {
			console.error('Error fetching practices:', error);
		}
	};
	const filteredPracticesData = practices?.filter((item) => {
		return searchText?.toLowerCase() === ''
			? practices
			: item.Name && item.Name.toLowerCase().includes(searchText.toLowerCase());
	});
	const fetchvisitcounts = async () => {
		try {
			const response = await getVisitCount();
			if (response?.status === 200) {
				// setvisitcounts(response?.data?.visits);
				dispatch({ type: actions.SET_PRACTICE_STATS, payload: response?.data });
			} else {
				// setvisitcounts([]);
				dispatch({ type: actions.SET_PRACTICE_STATS, payload: [] });
			}
		} catch (error) {
			console.error('Error fetching practices count:', error);
		}
	};
	useEffect(() => {
		fetchPractices();
		fetchvisitcounts();
		settingLocationName();
		sliderApiData();
	}, []);

	const theme = useTheme();
	// const [{user,practice},dispatch] = useStateValue();
	const user = localStorage.getItem('userName');
	const practice = localStorage.getItem('prName');
	// console.log("pr:",practice)

	const [openModal, setOpenModal] = React.useState(false);

	const handleEditProvider = (id) => {
		// Here you can perform any necessary actions before opening the modal
		setOpenModal(true);
	};

	const handleCloseEditModal = () => {
		setOpenModal(false);
	};

	// notifications and profile settings togggle functions here
	const settings = ['Profile', 'Logout'];

	const [anchorElUser, setAnchorElUser] = React.useState(null);

	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const [anchorElNotifications, setAnchorElNotifications] =
		React.useState(null);

	const [showNotificationSettings, setShowNotificationSettings] =
		React.useState(false);

	// for checking cuurent location with help of react router dom
	const currentlocation = useLocation();
	const [locationName, setLocationName] = React.useState(
		currentlocation.pathname
	);

	const settingLocationName = () => {
		setLocationName(
			currentlocation.pathname.slice(1).charAt(0).toUpperCase() +
				currentlocation.pathname.slice(2).replace(/_/g, ' ')
		);
	};

	const [loading, setLoading] = useState(false); // State to track loading

	return (
		<Grid
			container
			sx={{
				backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				objectFit: 'contain',
				backgroundPosition: 'center',
				boxShadow: '0px 1px 15px 0px rgba(255, 255, 255, 0.56)',
				height: '100vh',
			}}
		>
			<Grid
				item
				xl={12}
				xs={12}
				md={12}
				sm={12}
				lg={12}
				display={'flex'}
				alignItems={'center'}
				height={'70px'}
			>
				<Grid
					item
					xl={12}
					xs={12}
					md={12}
					sm={12}
					lg={12}
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<img src={websitelogo} style={{ width: '12%' }} />
					<Button
						sx={{
							display: 'flex',
							alignItems: 'center',
							borderRadius: '30px',
						}}
						onClick={handleOpenUserMenu}
					>
						<Box sx={{ padding: '5px 10px' }}>
							<Typography
								fontSize={'15px'}
								fontWeight={500}
								fontFamily={'Poppins'}
								color={'white'}
							>
								{user}
							</Typography>
						</Box>
						<Tooltip title="Open Profile menu">
							<IconButton sx={{ p: 0, mr: 2 }}>
								{/* <img src={userIconPng} alt="usericon" width={'30px'} /> */}
								<AccountCircleIcon sx={{ color: 'white' }} />
							</IconButton>
						</Tooltip>
					</Button>
				</Grid>
			</Grid>
			<Menu
				sx={{ mt: '45px' }}
				id="menu-appbar"
				anchorEl={anchorElUser}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				keepMounted
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={Boolean(anchorElUser)}
				onClose={handleCloseUserMenu}
			>
				<MenuItem sx={{ flexDirection: 'column' }} onClick={handleEditProvider}>
					<Box
						width={'100%'}
						gap={1}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
					>
						<Feedback fontSize="10px" />
						<Typography
							width={'60%'}
							textAlign={'start'}
							color={'#404040'}
							fontSize={'12px'}
							fontWeight={400}
						>
							Feedback
						</Typography>
					</Box>
				</MenuItem>
				<Modal
					open={openModal}
					onClose={handleCloseEditModal}
					aria-labelledby="edit-modal-title"
					aria-describedby="edit-modal-description"
					sx={{
						'& .MuiModal-backdrop': {
							opacity: '30 !important',
						},
					}}
				>
					<Box sx={{ style }}>
						<FeedbackPopup onClose={handleCloseEditModal} />
					</Box>
				</Modal>

				<MenuItem
					sx={{ flexDirection: 'column' }}
					onClick={() => {
						logoutFunc();
						navigate('/');
					}}
				>
					<Box
						width={'100%'}
						gap={1}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
					>
						<Box width={'15%'}>
							<img src={logoutPng} alt="logout icon" width={'10px'} />
						</Box>
						<Typography
							width={'60%'}
							textAlign={'start'}
							color={'#404040'}
							fontSize={'12px'}
							fontWeight={400}
						>
							Logout
						</Typography>
					</Box>
				</MenuItem>
			</Menu>
			{practices?.length > 0 && (
				<>
					<Grid
						item
						xl={12}
						xs={12}
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							alignItems: 'center',
							gap: '2rem',
							// marginBottom: '115px',
							// border: '1px solid yellow',
							height: '40px',
							marginBottom: '40px',
						}}
					>
						<Typography
							variant="h4"
							sx={{
								color: '#292828',
								fontFamily: 'Poppins',
								fontSize: {
									xl: '25px',
									lg: '20px',
									md: '20px',
									sm: '20px',
									xs: '20px',
								},
								fontStyle: 'normal',
								textAlign: 'center',
								fontWeight: '500',
								color: 'white',
							}}
						>
							Select a Practice To Proceed
						</Typography>
						<Paper
							component="form"
							sx={{
								// p: '2px 4px',
								display: 'flex',
								alignItems: 'center',
								width: {
									xl: 380,
									lg: 280,
									md: 280,
									sm: 280,
									xs: 280,
								},
								border: '1px solid #00000030',
							}}
						>
							<Input
								placeholder="Search "
								sx={{ ml: 1, flex: 1 }}
								value={searchText}
								onChange={(e) => setSearchText(e.target.value)}
								disableUnderline
							/>
							<IconButton type="button" sx={{ p: '5px' }} aria-label="search">
								<SearchIcon />
							</IconButton>
						</Paper>
					</Grid>
				</>
			)}
			{loading ? (
				<div
					style={{
						height: '72vh',
						width: '100%',
						display: 'flex',
						justifyContent: 'center',
					}}
				>
					<div className="logo-container">
						<img
							style={{
								width: '40%',
								display: 'flex',
								justifyContent: 'center',
								paddingLeft: '200px',
								paddingTop: '150px',
							}}
							src={websitelogo}
							alt="Website Logo"
						/>
					</div>
				</div>
			) : (
				<Grid container>
					<Grid
						item
						width={'100%'}
						display={'flex'}
						justifyContent="center"
						flexDirection={'row'}
						flexWrap={'wrap'}
						sx={{
							overflow: 'auto',
							height: {
								xs: '50vh',
								sm: '50vh',
								md: '30vh',
								lg: '30vh',
								xl: '30vh',
							},
							marginBottom: '150px',
						}}
					>
						{filteredPracticesData &&
							filteredPracticesData.length > 0 &&
							filteredPracticesData.map((practice, key) => (
								<>
									<Grid
										item
										lg={3.5}
										xl={3.5}
										md={4}
										sm={8}
										xs={12}
										sx={{ padding: '5px' }}
										key={practice?.id}
										height={'250px'}
										fontFamily={'poppins'}
									>
										<Box
											sx={{
												display: 'flex',
												justifyContent: 'flex-start',
												alignItems: 'flex-start',
											}}
										>
											<Button onClick={() => handlepractice(practice)}>
												<Grid
													item
													container
													// alignItems="center"
													sx={{
														borderRadius: '10px',
														border: '1px solid rgba(0, 0, 0, 0.65)',
														background: '#FFF',
														// boxShadow: '0px 1px 20px 0px rgba(0, 0, 0, 0.25)',
														display: 'flex',
														justifyContent: 'center',
													}}
												>
													<Grid item xs={12} lg={12} md={12}>
														<Typography
															variant="body1"
															sx={{
																color: '#292828',
																textAlign: 'center',
																fontFamily: 'Poppins',
																fontSize: '14px',
																borderTopLeftRadius: '10px',
																borderTopRightRadius: '10px',
																fontStyle: 'normal',
																background: '#0E4374',
																color: 'white',
																fontWeight: '400',
																whiteSpace: 'nowrap',
																textOverflow: 'ellipsis',
																borderBottom: '1px solid #615959',
																padding: '10px 12px',
																'@media only screen and (max-width: 1920px) and (min-width: 1760px)':
																	{
																		// Styles for xs and sm screens
																		fontSize: '17px',
																		fontWeight: '600',
																	},
																'@media only screen and (max-width: 1750px) and (min-width: 1500px)':
																	{
																		// Styles for xs and sm screens
																		fontSize: '12px',
																		fontWeight: '500',
																	},
																'@media only screen and (max-width: 1430px) and (min-width: 900px)':
																	{
																		// Styles for xs and sm screens
																		fontSize: '12px',
																		fontWeight: '500',
																	},
															}}
														>
															{practice.Name}
															{'-'}
															{practice.id}
														</Typography>
													</Grid>
													<Grid container item sx={{}}>
														<Grid
															container
															item
															xs={12}
															lg={12}
															xl={12}
															md={12}
														>
															<Grid
																item
																container
																xs={6}
																md={6}
																lg={6}
																xl={6}
																sx={{
																	display: 'flex',
																	justifyContent: 'center',
																	alignItems: 'center',
																	padding: '5px',
																}}
															>
																<Grid
																	md={12}
																	lg={12}
																	item
																	sx={{
																		borderRadius: '6px',
																		background: '#F6F6F6',
																		background: '#F6F6F6',
																		borderRadius: '8px',
																		padding: '15px',
																		// border: '0.5px solid lightgray',
																	}}
																>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#605555',
																			// textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '12px',
																			fontWeight: '400',
																			whiteSpace: 'nowrap',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '9px',
																					fontWeight: '400',
																				},
																		}}
																	>
																		Approved visits
																	</Typography>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#1D60C5',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '14px',
																			fontWeight: '600',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '10px',
																					fontWeight: '600',
																				},
																		}}
																	>
																		{'('}
																		{visitcounts &&
																			(() => {
																				let foundCount = 0;
																				for (const item of visitcounts) {
																					if (
																						item?.id == practice?.id &&
																						item.Status == 'A'
																					) {
																						if (foundCount === 0) {
																							foundCount = item.cnt;
																							break;
																						} else {
																							foundCount = 0;
																							break;
																						}
																					}
																				}
																				return foundCount !== 0
																					? foundCount
																					: 0;
																			})()}
																		{')'}
																	</Typography>
																</Grid>
															</Grid>
															<Grid
																item
																container
																xs={6}
																md={6}
																lg={6}
																xl={6}
																sx={{
																	display: 'flex',
																	justifyContent: 'center',
																	alignItems: 'center',
																	padding: '5px',
																}}
															>
																<Grid
																	md={12}
																	lg={11}
																	item
																	sx={{
																		borderRadius: '6px',
																		background: '#F6F6F6',
																		background: '#F6F6F6',
																		borderRadius: '8px',
																		padding: '15px',
																		// border: '0.5px solid lightgray',
																	}}
																>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#605555',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '12px',
																			fontWeight: '400',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '9px',
																					fontWeight: '400',
																				},
																		}}
																	>
																		Draft visits
																	</Typography>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#FF7E07',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '15px',
																			fontWeight: '600',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '10px',
																					fontWeight: '600',
																				},
																		}}
																	>
																		{'('}
																		{visitcounts &&
																			(() => {
																				let foundCount = 0;
																				for (const item of visitcounts) {
																					if (
																						item?.id == practice?.id &&
																						item.Status == 'D'
																					) {
																						if (foundCount === 0) {
																							foundCount = item.cnt;
																							break;
																						} else {
																							foundCount = 0;
																							break;
																						}
																					}
																				}
																				return foundCount !== 0
																					? foundCount
																					: 0;
																			})()}
																		{')'}
																	</Typography>
																</Grid>
															</Grid>
														</Grid>
														<Grid container item xs={12}>
															<Grid
																item
																container
																xs={6}
																md={6}
																lg={6}
																xl={6}
																sx={{
																	display: 'flex',
																	justifyContent: 'center',
																	alignItems: 'center',
																	padding: '5px',
																}}
															>
																<Grid
																	md={12}
																	lg={12}
																	xl={12}
																	item
																	sx={{
																		borderRadius: '6px',
																		background: '#F6F6F6',
																		background: '#F6F6F6',
																		borderRadius: '8px',
																		padding: '15px',
																		// border: '0.5px solid lightgray',
																	}}
																>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#605555',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '12px',
																			fontWeight: '400',
																			whiteSpace: 'nowrap',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '9px',
																					fontWeight: '400',
																				},
																		}}
																	>
																		Rejected Visits
																	</Typography>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#ED2828',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '15px',
																			fontWeight: '600',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '10px',
																					fontWeight: '600',
																				},
																		}}
																	>
																		{'('}
																		{visitcounts &&
																			(() => {
																				let foundCount = 0;
																				for (const item of visitcounts) {
																					if (
																						item?.id == practice?.id &&
																						item.Status == 'O'
																					) {
																						if (foundCount === 0) {
																							foundCount = item.cnt;
																							break;
																						} else {
																							foundCount = 0;
																							break;
																						}
																					}
																				}
																				return foundCount !== 0
																					? foundCount
																					: 0;
																			})()}
																		{')'}
																	</Typography>
																</Grid>
															</Grid>
															<Grid
																item
																container
																xs={6}
																md={6}
																lg={6}
																xl={6}
																sx={{
																	display: 'flex',
																	justifyContent: 'center',
																	alignItems: 'center',
																	padding: '5px',
																}}
															>
																<Grid
																	md={12}
																	lg={11}
																	item
																	sx={{
																		borderRadius: '6px',
																		background: '#F6F6F6',
																		background: '#F6F6F6',
																		borderRadius: '8px',
																		// border: '0.5px solid lightgray',

																		padding: '15px',
																	}}
																>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#605555',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '12px',
																			fontWeight: '400',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '9px',
																					fontWeight: '400',
																				},
																		}}
																	>
																		Billed visits
																	</Typography>
																	<Typography
																		variant="body2"
																		sx={{
																			color: '#036210',
																			textAlign: 'center',
																			fontFamily: 'Poppins',
																			fontSize: '15px',
																			fontWeight: '600',
																			'@media only screen and (max-width: 1300px) and (min-width: 900px)':
																				{
																					// Styles for xs and sm screens
																					fontSize: '10px',
																					fontWeight: '600',
																				},
																		}}
																	>
																		{'('}
																		{visitcounts &&
																			(() => {
																				let foundCount = 0;
																				for (const item of visitcounts) {
																					if (
																						item?.id == practice?.id &&
																						item.Status == 'B'
																					) {
																						if (foundCount === 0) {
																							foundCount = item.cnt;
																							break;
																						} else {
																							foundCount = 0;
																							break;
																						}
																					}
																				}
																				return foundCount !== 0
																					? foundCount
																					: 0;
																			})()}
																		{')'}
																	</Typography>
																</Grid>
															</Grid>
														</Grid>
													</Grid>
												</Grid>
											</Button>
										</Box>
									</Grid>
								</>
							))}
						{practices?.length === 0 && (
							<Grid
								container
								item
								display="flex"
								alignItems="center"
								justifyContent="centter"
								// flexDirection="column"
								gap="15px"
								// alignItems="center"
								sx={{
									padding: '20px',
									height: {
										xl: '70vh',
										lg: '70vh',
										md: '65vh',
										sm: '65vh',
										xs: '65vh',
									},
								}}
							>
								<Grid
									item
									xs={12}
									lg={12}
									xl={12}
									display="flex"
									alignItems="center"
									justifyContent="centter"
									flexDirection="column"
									gap="20px"
								>
									<Grid item>
										<Typography
											variant="h4"
											sx={{
												fontFamily: 'Poppins',
												color: 'white',
												fontSize: {
													xl: '33px',
													lg: '25px',
													md: '25px',
													sm: '25px',
													xs: '20px',
												},
												fontWeight: '600',
											}}
										>
											Thankyou !
										</Typography>
									</Grid>
									<Grid item>
										<Typography
											variant="body1"
											sx={{
												fontFamily: 'Poppins',
												color: 'white',
												fontSize: {
													xl: '16px',
													lg: '13px',
													md: '13px',
													sm: '13px',
													xs: '10px',
												},
												fontWeight: '600',
											}}
										>
											For Signing Up in Maxremind Charts !
										</Typography>
									</Grid>
									<Grid item>
										<Typography
											variant="body2"
											sx={{
												fontFamily: 'Poppins',
												color: 'white',
												// fontSize: '33px',
												// fontWeight: '600',
												fontSize: {
													xl: '14px',
													lg: '11px',
													md: '11px',
													sm: '11px',
													xs: '10px',
												},
											}}
										>
											Your request has been submitted, and our
											<br /> sales team will get back to you shortly to
											<br /> complete the &quot; <span>Enrollment Process</span>
											&quot;
										</Typography>
									</Grid>
									<Grid item>
										<Box
											sx={{
												background: 'lightgray',
												borderRadius: '5px',
												padding: '7px 15px',
												display: 'flex',
												alignItems: 'center',
												gap: '7px',
												margin: ' 8px 5px',
												// flexDirection: 'column',
											}}
										>
											<Box
												sx={{
													borderRadius: '50px',
													padding: '6px',
													background: '#fff',
													display: 'flex',
													alignItems: 'center',
												}}
											>
												<MailOutlineOutlinedIcon
													sx={{ color: 'lightcoral' }}
													fontSize="small"
												/>{' '}
											</Box>
											<Typography variant="body1">
												<Link to="mailto:'sales@mremind.com' ">
													sales@mremind.com
												</Link>
											</Typography>
										</Box>
										<Box
											sx={{
												background: 'lightgray',
												borderRadius: '5px',
												padding: '7px 15px',
												display: 'flex',
												alignItems: 'center',
												gap: '7px',
												margin: ' 8px 5px',
												// flexDirection: 'column',
											}}
										>
											<Box
												sx={{
													borderRadius: '50px',
													padding: '6px',
													background: '#fff',
													display: 'flex',
													alignItems: 'center',
												}}
											>
												<LanguageIcon
													sx={{ color: 'lightcoral' }}
													fontSize="small"
												/>{' '}
											</Box>

											<Typography variant="body1">
												{' '}
												<Link
													to="https://www.mremind.com/"
													target="_blank"
													rel="noopener noreferrer"
												>
													mremind.com
												</Link>
											</Typography>
										</Box>
										<Box
											sx={{
												background: 'lightgray',
												borderRadius: '5px',
												padding: '7px 15px',
												display: 'flex',
												alignItems: 'center',
												gap: '7px',
												margin: ' 8px 5px',
												// flexDirection: 'column',
											}}
										>
											<Box
												sx={{
													borderRadius: '50px',
													padding: '6px',
													background: '#fff',
													display: 'flex',
													alignItems: 'center',
												}}
											>
												<LocalPhoneIcon
													sx={{ color: 'lightcoral' }}
													fontSize="small"
												/>{' '}
											</Box>
											<Typography variant="subtitle2">
												<Link to="tel:+12147363533">(214) 736-3533</Link> or
												<Link to="tel:+14693469843">(469) 346-9843</Link>
											</Typography>
										</Box>
									</Grid>
								</Grid>
								<Grid
									item
									xl={12}
									lg={12}
									display={'flex'}
									justifyContent={'flex-end'}
									alignItems={'flex-end'}
								>
									<Button
										// fullWidth
										variant="contained"
										onClick={() => {
											logoutFunc();
											navigate('/');
										}}
										sx={{
											background: 'orange',
											color: 'white',
											borderRadius: '5px',
											padding: '7px 15px',
											gap: '7px',
											margin: ' 8px 5px',
											'&:hover': {
												background: 'orange',
											},
											// flexDirection: 'column',
										}}
									>
										ok
									</Button>
								</Grid>
							</Grid>
						)}
					</Grid>

					<Box
						sx={{
							width: '80%',
							height: '80px',
							margin: 'auto',
							marginBottom: '8%',
							display: {
								xs: 'none',
								sm: 'none',
								md: 'block',
								lg: 'block',
								xl: 'block',
							},
						}}
					>
						<Slider
							dots={false}
							infinite={true}
							slidesToShow={4}
							slidesToScroll={1}
							autoplay={true}
							speed={500}
							autoplaySpeed={3000}
							cssEase={'linear'}
							nextArrow={
								<ArrowForwardIos
									sx={{
										color: 'white',
										fontSize: '40px',
										marginRight: '-20px',
										'&:hover': { color: 'white' },
									}}
								/>
							}
							prevArrow={
								<ArrowBackIos
									sx={{
										color: 'white',
										fontSize: '40px',
										marginLeft: '-20px',
										'&:hover': { color: 'white' },
									}}
								/>
							}
						>
							{sliderData?.map((item, key) => {
								return (
									<Box
										key={key}
										sx={{
											width: '10%',
											height: '100px',
										}}
									>
										<Box
											display={'flex'}
											height={'inherit'}
											margin={'0 15px'}
											bgcolor={'white'}
											borderRadius={'0.5rem'}
											sx={{ cursor: 'pointer' }}
											onClick={() => {
												const isAppleDevice = /iPhone|iPad|iPod/i.test(
													navigator.userAgent
												);
												const storeUrl = isAppleDevice
													? item.ASurl
													: item.PSurl;
												window.open(storeUrl, '_blank');
											}}
										>
											{/* 1st */}
											<Box
												bgcolor={'#D4E7F5'}
												borderRadius={'0.5rem 0 0 0.5rem'}
												display={'flex'}
												justifyContent={'center'}
												alignItems={'center'}
												padding={'5px'}
											>
												<Box
													sx={{ width: '60px' }}
													component={'img'}
													src={`https://api.maxremind.technology//Photos/MxR/${item?.AppImgName}`}
												/>
											</Box>
											{/* 2nd */}
											<Box
												padding={'5px'}
												display={'flex'}
												flexDirection={'column'}
												// gap={"3px"}
											>
												<Typography
													sx={{
														color: '#1C6697',
														fontSize: '12px',
														fontWeight: 'bold',
														textAlign: 'center',
														fontFamily: 'Poppins',
													}}
												>
													{item?.AppName}
												</Typography>
												<Typography
													sx={{
														fontSize: {
															xl: '10px',
															lg: '9px',
															md: '6px',
															sm: '7px',
															xs: '7px',
														},
														//  '10px',
														margin: '5px',
														fontFamily: 'Poppins',
													}}
												>
													{item?.AppDescription?.length < 80
														? item?.AppDescription
														: item?.AppDescription?.slice(0, 80)}
													{item?.AppDescription?.length > 80 && (
														<span
															style={{
																color: '#115184',
																textDecoration: 'underline',
																cursor: 'pointer',
																// fontSize: '12px',
																marginLeft: '2%',
																fontSize: {
																	xl: '10px',
																	lg: '10px',
																	md: '7px',
																	sm: '7px',
																	xs: '7px',
																},
															}}
														>
															Read More...
														</span>
													)}
												</Typography>
											</Box>
										</Box>
									</Box>
								);
							})}
						</Slider>
					</Box>
				</Grid>
			)}
		</Grid>
	);
}

export default SelectPracticev2;
